<template>
    <section class="survey">
        <slot></slot>
    </section>
</template>

<script>
export default {
    name: 'survey'
}
</script>
